import { Trans } from "@lingui/react/macro"
import { IconVocabulary } from "@tabler/icons-react"
import { JargonSuggestionList } from "../../../JargonSuggestionList"
import sharedClasses from "../../styles.module.css"
import type { IProps } from "./interfaces"

/**
 * SuggestedJargonCard wraps the shared jargon review rows in the meeting insights
 * rail: an icon + "Suggested terms" heading, a count tag, and a one-line pitch,
 * with the per-word Accept / Dismiss rows rendered by JargonSuggestionList in its
 * compact "card" chrome. Dumb component — the host owns the data + mutations.
 *
 * The parent decides whether to mount it; an empty list still returns null so a
 * meeting with no suggestions shows no card.
 */
export function SuggestedJargonCard({
  suggestions,
  onAccept,
  onDismiss,
  busyId = null,
}: IProps): React.JSX.Element | null {
  if (!suggestions || suggestions.length === 0) return null

  return (
    <section className={sharedClasses.insight}>
      <div className={sharedClasses.insightHead}>
        <IconVocabulary size={16} color="var(--mantine-color-brand-5)" />
        <h3>
          <Trans>Suggested terms</Trans>
        </h3>
        <span className={sharedClasses.insightTag}>{suggestions.length}</span>
      </div>
      <p className={sharedClasses.insightBody}>
        <Trans>
          Domain words detected in this meeting. Add them to your dictionary so future transcripts get them right.
        </Trans>
      </p>
      <JargonSuggestionList
        variant="card"
        suggestions={suggestions}
        onAccept={onAccept}
        onDismiss={onDismiss}
        busyId={busyId}
      />
    </section>
  )
}
